export const COUNTRIES = [
  { code: 'AT', name: 'Austria' },
  { code: 'DE', name: 'Germany' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'FR', name: 'France' },
  { code: 'ES', name: 'Spain' },
  { code: 'IT', name: 'Italy' },
  { code: 'BE', name: 'Belgium' },
]

export const BUSINESS_TYPES = [
  { value: 'Studio Yoga', label: 'Studio Yoga' },
  { value: 'Studio Dance', label: 'Studio Dance' },
  { value: 'Studio Fitness', label: 'Studio Fitness' },
  { value: 'Funsport', label: 'Funsport' },
]

export const MAIN_VERTICALS = [
  { value: 'Badminton', label: 'Badminton' },
  { value: 'Beachvolleyball', label: 'Beachvolleyball' },
  { value: 'Bowling', label: 'Bowling' },
  { value: 'Boxing', label: 'Boxing' },
  { value: 'Children Activity', label: 'Children Activity' },
  { value: 'Climbing', label: 'Climbing' },
  { value: 'CrossFit', label: 'CrossFit' },
  { value: 'Curling', label: 'Curling' },
  { value: 'EMS', label: 'EMS' },
  { value: 'Football', label: 'Football' },
  { value: 'Functional Training', label: 'Functional Training' },
  { value: 'Group Dance', label: 'Group Dance' },
  { value: 'Group Fun', label: 'Group Fun' },
  { value: 'Gym', label: 'Gym' },
  { value: 'Indoor Golf', label: 'Indoor Golf' },
  { value: 'Indoor Group Fitness', label: 'Indoor Group Fitness' },
  { value: 'Jumping Fitness', label: 'Jumping Fitness' },
  { value: 'Jumping Park', label: 'Jumping Park' },
  { value: 'Martial Arts', label: 'Martial Arts' },
  { value: 'Meditation', label: 'Meditation' },
  { value: 'Multisports', label: 'Multisports' },
  { value: 'Other', label: 'Other' },
  { value: 'Outdoor Fitness', label: 'Outdoor Fitness' },
  { value: 'Padel', label: 'Padel' },
  { value: 'Pair Dance', label: 'Pair Dance' },
  { value: 'Personal Training', label: 'Personal Training' },
  { value: 'Physiotherapist', label: 'Physiotherapist' },
  { value: 'Pilates', label: 'Pilates' },
  { value: 'Pole Dance', label: 'Pole Dance' },
  { value: 'Rowing', label: 'Rowing' },
  { value: 'Spinning', label: 'Spinning' },
  { value: 'Squash', label: 'Squash' },
  { value: 'Stand Up Paddling', label: 'Stand Up Paddling' },
  { value: 'Swimming', label: 'Swimming' },
  { value: 'Table Tennis', label: 'Table Tennis' },
  { value: 'Tennis', label: 'Tennis' },
  { value: 'Wellness', label: 'Wellness' },
  { value: 'Yoga', label: 'Yoga' },
  { value: 'Reformer Pilates', label: 'Reformer Pilates' },
]

export const AGGREGATORS = [{ value: 'USCScheduling', label: 'Urban Sports Club' }]
